import React from "react";
import { TrashIcon, Loader2 } from "lucide-react";
import { usePostAuth } from "../../../hooks/usePostAuth";

interface DeleteButtonProps {
  invitationId: number;
}

export const DeleteButton: React.FC<DeleteButtonProps> = ({ invitationId }) => {
  const { mutate, isPending } = usePostAuth(`invitations/${invitationId}`, {
    queryKeyToInvalidate: ["get-invitations"],
  });

  const handleClick = () => {
    if (isPending) return;
    mutate({ _method: "DELETE" });
  };

  return (
    <button
      onClick={handleClick}
      disabled={isPending}
      className={`
        inline-flex items-center gap-1 px-3 py-2 
        bg-red-500 hover:bg-red-600 disabled:bg-red-400 
        text-white rounded-md text-sm font-medium 
        transition-colors duration-200
      `}
      title="Revoke"
    >
      {isPending ? (
        <Loader2 className="animate-spin" size={16} />
      ) : (
        <TrashIcon size={16} />
      )}
      <span className="hidden sm:inline">
        {isPending ? "Revoke…" : "Revoke"}
      </span>
    </button>
  );
};
